import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

export const FadeIn = ({ children, delay = 0, className = '' }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-60px' });
  return (
    <motion.div ref={ref} initial={{ opacity: 0, y: 30 }} animate={isInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.6, delay }} className={className}>
      {children}
    </motion.div>
  );
};

export const PageHero = ({ label, title, description, image, imageAlt }) => (
  <section className="relative overflow-hidden min-h-[55vh] flex items-end">
    {image ? (
      <>
        <div className="absolute inset-0">
          <img
            src={image}
            alt={imageAlt || `${title} – Staffing Force`}
            className="w-full h-full object-cover"
            loading="eager"
            fetchpriority="high"
            width="1920"
            height="1080"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-[#0d1b2a]/95 via-[#0d1b2a]/75 to-[#00897B]/50" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0d1b2a]/90 via-transparent to-transparent" />
        </div>
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#00bfa5]/15 rounded-full blur-3xl" />
        <div className="absolute -bottom-20 -left-20 w-96 h-96 bg-[#00897B]/20 rounded-full blur-3xl" />
      </>
    ) : (
      <>
        <div className="absolute inset-0 bg-[#0d1b2a]" />
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#00897B]/10 rounded-full blur-3xl" />
      </>
    )}
    <div className="max-w-7xl mx-auto px-6 lg:px-8 relative w-full pt-20 pb-14 md:pb-16">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
        <span className="text-[#00bfa5] text-xs md:text-sm font-semibold tracking-widest uppercase">{label}</span>
        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-white mt-3 mb-5 leading-[1.05]">{title}</h1>
        {description && <p className="text-white/80 text-sm md:text-lg max-w-3xl leading-relaxed">{description}</p>}
      </motion.div>
    </div>
  </section>
);

export const SectionTitle = ({ label, title, description, center = true }) => (
  <div className={`mb-12 ${center ? 'text-center' : ''}`}>
    {label && <span className="text-[#00897B] text-sm font-semibold tracking-widest uppercase">{label}</span>}
    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2">{title}</h2>
    {description && <p className="text-gray-600 mt-3 max-w-2xl mx-auto">{description}</p>}
  </div>
);
